// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    window.history.replaceState(null, "", window.location.pathname);

    (async () => {
      try {
        const { data: user } = await api.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        toast.success(`Bentornato/a, ${user.name || user.email}!`);
        if (user.needs_consent) {
          navigate("/consenso", { replace: true });
        } else if (user.role === "admin") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (e) {
        const msg = formatApiErrorDetail(e.response?.data?.detail) || "Login Google fallito";
        toast.error(msg);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8F9]" data-testid="auth-callback-page">
      <div className="flex flex-col items-center gap-4 text-slate-600">
        <Loader2 className="w-8 h-8 animate-spin text-[#0F7B85]" />
        <div className="text-sm tracking-wider uppercase">Accesso in corso…</div>
      </div>
    </div>
  );
}
